import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import SettingsIcon from '@mui/icons-material/Settings';
import AddIcon from '@mui/icons-material/Add';
import ListIcon from '@mui/icons-material/List';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import HistoryIcon from '@mui/icons-material/History';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import SecurityIcon from '@mui/icons-material/Security';
import TimelineIcon from '@mui/icons-material/Timeline';
import HomeIcon from '@mui/icons-material/Home';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import GroupIcon from '@mui/icons-material/Group';
import LogoutIcon from '@mui/icons-material/Logout';
import AssessmentIcon from '@mui/icons-material/Assessment';

const iconMap = {
  Dashboard: DashboardIcon,
  Folder: FolderIcon,
  Description: DescriptionIcon,
  Settings: SettingsIcon,
  Add: AddIcon,
  List: ListIcon,
  CalendarToday: CalendarTodayIcon,
  History: HistoryIcon,
  People: PeopleIcon,
  Person: PersonIcon,
  Security: SecurityIcon,
  Timeline: TimelineIcon,
  Home: HomeIcon,
  HomeWork: HomeWorkIcon,
  PersonAdd: PersonAddIcon,
  TrendingUp: TrendingUpIcon,
  Group: GroupIcon,
  Logout: LogoutIcon,
  Assessment: AssessmentIcon,
};

const Icon = ({ name, ...props }) => {
  const IconComponent = iconMap[name];
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  return <IconComponent {...props} />;
};

export default Icon;
